import AccountBalanceTwoToneIcon from '@mui/icons-material/AccountBalanceTwoTone'
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone'
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutlineTwoTone'
import SchoolTwoToneIcon from '@mui/icons-material/SchoolTwoTone'
import WorkTwoToneIcon from '@mui/icons-material/WorkTwoTone'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import { styled } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { CustomThemeContext } from 'common/providers/CustomThemeProvider'
import Organigrama from 'features/organigrama/pages/Organigrama'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import TabPanel from '../components/TabPanel'
import WorkerData from '../components/WorkerData'
import useFetchOtherData from '../hooks/useFetchOtherData'
import useFetchWorkerData from '../hooks/useFetchWorkerData'
import Bancarios from '../subpages/Bancarios'
import Curriculum from '../subpages/Curriculum'
import Personales from '../subpages/Personales'
import Profesionales from '../subpages/Profesionales'

const DatosTrabajador = () => {
  const { themeController } = useContext(CustomThemeContext)

  const location = useLocation()
  const [user] = useState(location?.state?.user ?? null)

  const { response, loading } = useFetchWorkerData(user)
  const { response: otherDataResponse } = useFetchOtherData(user)

  const [datos, setDatos] = useState(response)
  const [otrosDatos, setOtrosDatos] = useState(otherDataResponse)

  useEffect(() => {
    setDatos(response)
  }, [response])

  useEffect(() => {
    setOtrosDatos(otherDataResponse)
  }, [otherDataResponse])

  const [value, setValue] = useState(0)

  const handleChange = (_, newValue) => {
    setValue(newValue)
  }

  const CustomWorkerData = themeController.components?.WorkerData

  const PillTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => {
    return {
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(15),
      marginRight: theme.spacing(1),
      color: theme.palette.primary.main,
      minHeight: 'unset',
      borderRadius: '1000px',
      backgroundColor: theme.palette.background.paper,
      '&.Mui-selected': {
        color: theme.palette.success.contrastText,
        backgroundColor: theme.palette.success.main,
      },
    }
  })

  return (
    <Box>
      <Box className="WorkerData" sx={{ marginTop: '63px' }}>
        <Card className="perfil" sx={{ width: '100%', overflow: 'initial' }}>
          {CustomWorkerData ? (
            <CustomWorkerData
              datos={datos}
              loading={loading}
              showingSubordinate={user ? true : false}
            />
          ) : (
            <WorkerData datos={datos} />
          )}
          {!themeController.options?.WorkerData?.subpageSelectors ||
          themeController.options?.WorkerData?.subpageSelectors === 'tabs' ? (
            <CardActions disableSpacing sx={{ justifyContent: 'flex-end' }}>
              <Tabs
                value={value}
                variant="scrollable"
                onChange={handleChange}
                aria-label="secciones datos trabajador"
                allowScrollButtonsMobile={true}
              >
                <Tab icon={<PersonOutlineTwoToneIcon />} iconPosition="start" label="Personal" />
                {themeController.hide?.WorkerData?.Professional?.Hide ? null : (
                  <Tab icon={<WorkTwoToneIcon />} iconPosition="start" label="Profesional" />
                )}
                {themeController.hide?.WorkerData?.Bank?.Hide ? null : (
                  <Tab
                    icon={<AccountBalanceTwoToneIcon />}
                    iconPosition="start"
                    label="Bancarios"
                  />
                )}
                {themeController.hide?.WorkerData?.Curriculum?.Hide ? null : (
                  <Tab icon={<SchoolTwoToneIcon />} iconPosition="start" label="Curriculum" />
                )}
                {themeController.hide?.WorkerData?.Organigram?.Hide ? null : (
                  <Tab icon={<AccountTreeTwoToneIcon />} iconPosition="start" label="Organigrama" />
                )}
              </Tabs>
            </CardActions>
          ) : null}
        </Card>
      </Box>

      {themeController.options?.WorkerData?.subpageSelectors === 'pills' ? (
        <Box
          sx={{
            mt: 5,
            mb: 1,
            width: { xs: '100%', md: 'fit-content' },
            ml: 'auto',
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          <Tabs
            value={value}
            variant="scrollable"
            onChange={handleChange}
            aria-label="secciones datos trabajador"
            allowScrollButtonsMobile={true}
          >
            <PillTab icon={<PersonOutlineTwoToneIcon />} iconPosition="start" label="Personal" />
            {themeController.hide?.WorkerData?.Professional?.Hide ? null : (
              <PillTab icon={<WorkTwoToneIcon />} iconPosition="start" label="Profesional" />
            )}
            {themeController.hide?.WorkerData?.Bank?.Hide ? null : (
              <PillTab
                icon={<AccountBalanceTwoToneIcon />}
                iconPosition="start"
                label="Bancarios"
              />
            )}
            {themeController.hide?.WorkerData?.Curriculum?.Hide ? null : (
              <PillTab icon={<SchoolTwoToneIcon />} iconPosition="start" label="Curriculum" />
            )}
            {themeController.hide?.WorkerData?.Organigram?.Hide ? null : (
              <PillTab icon={<AccountTreeTwoToneIcon />} iconPosition="start" label="Organigrama" />
            )}
          </Tabs>
        </Box>
      ) : null}

      <TabPanel value={value} index={0}>
        <Personales datosTrabajador={datos} otrosDatos={otrosDatos} />
      </TabPanel>
      {themeController.hide?.WorkerData?.Professional?.Hide ? null : (
        <TabPanel value={value} index={1}>
          <Profesionales otrosDatos={otrosDatos} />
        </TabPanel>
      )}
      {themeController.hide?.WorkerData?.Bank?.Hide ? null : (
        <TabPanel value={value} index={2}>
          <Bancarios datosTrabajador={datos} />
        </TabPanel>
      )}
      {themeController.hide?.WorkerData?.Curriculum?.Hide ? null : (
        <TabPanel value={value} index={3}>
          <Curriculum />
        </TabPanel>
      )}
      {themeController.hide?.WorkerData?.Organigram?.Hide ? null : (
        <TabPanel value={value} index={4}>
          <Organigrama />
        </TabPanel>
      )}
    </Box>
  )
}

export default DatosTrabajador
